import { render, staticRenderFns } from "./DialogTaoPhieuThuKhac.vue?vue&type=template&id=e08a3e44"
import script from "./DialogTaoPhieuThuKhac.vue?vue&type=script&lang=js"
export * from "./DialogTaoPhieuThuKhac.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports